// extracted by mini-css-extract-plugin
module.exports = {"title":"login_title__98DCD","formContainer":"login_formContainer__X7FQf","form":"login_form__fv4nC","forgotPassword":"login_forgotPassword__mQ2Up"};